// @ts-nocheck
/**
 * MaximizedPlayerManager - Handles maximizing Twitch players
 */
export class MaximizedPlayerManager {
    constructor(playerManager) {
        this.playerManager = playerManager;
    }

    /**
     * Toggle maximized state for a player
     */
    maximizePlayer(streamerId) {
        const player = this.playerManager.players.get(streamerId);
        if (!player) return;
        
        // Désactiver le mode zoom d'abord si actif pour tous les players
        this.playerManager.players.forEach((p, id) => {
            if (p.zoomed) {
                this.playerManager.disableZoomMode(id);
            }
            if (id !== streamerId && p.maximized) {
                this.playerManager.disableMaximizedMode(id);
            }
        });
        
        // Toggle state
        player.maximized = !player.maximized;

        if (player.maximized) {
            this.playerManager.focusAudioOnPlayer(streamerId);
        }
        
        // Use CSS custom properties for transitions
        document.documentElement.style.setProperty('--player-transition', 'all 0.3s ease');
        
        // Apply changes to all players
        requestAnimationFrame(() => {
            this.playerManager.container.classList.toggle('maximized-active', player.maximized);
            this.playerManager.container.parentElement?.classList.toggle('player-maximized-active', player.maximized);

            // Reset order properties first when maximizing or minimizing
            this.playerManager.players.forEach((p) => {
                p.element.style.order = '';
            });
            
            this.playerManager.players.forEach((p, id) => {
                if (id === streamerId) {
                    p.element.classList.toggle('player-maximized', player.maximized);
                    p.element.classList.remove('player-maximized-background');
                    // For maximized player, use grid span instead of order
                    p.element.style.gridColumn = p.maximized ? "1 / -1" : "";
                    p.element.style.gridRow = p.maximized ? "1 / -1" : "";
                    p.element.style.zIndex = p.maximized ? "10" : "";
                    p.element.style.order = p.maximized ? "-1" : "";
                    
                } else {
                    p.element.classList.remove('player-maximized');
                    // Twitch peut suspendre un embed qui passe en display:none. Les
                    // players secondaires restent donc rendus dans la grille.
                    p.element.classList.toggle('player-maximized-background', player.maximized);
                    p.element.style.gridColumn = '';
                    p.element.style.gridRow = '';
                    p.element.style.zIndex = '';
                    p.element.style.order = '';
                    
                    // S'assurer qu'aucune classe de zoom résiduelle ne reste
                    p.element.classList.remove('player-zoomed', 'player-below-zoomed');
                    
                }
            });
            
            // Supprimer la classe zoom-active du container
            this.playerManager.container.classList.remove('zoom-active');
            
            // Update button icon
            const button = player.element.querySelector('.player-controls button:nth-child(2) i');
            button.className = player.maximized ? 'fas fa-compress' : 'fas fa-expand';
            this.playerManager.syncPlayerModeControls(streamerId);
            
            // Important: Reset the grid-auto-flow property when maximizing
            if (player.maximized) {
                this.playerManager.container.style.gridAutoFlow = 'row';
            } else {
                this.playerManager.players.forEach((p) => {
                    p.element.classList.remove('player-maximized-background');
                });
                // And set back to dense when returning to normal
                this.playerManager.container.style.gridAutoFlow = 'dense';
                // Update layout if not maximized anymore
                this.playerManager.updateLayout();
            }

            this.playerManager.syncAllPlayerPerformance();

        });
    }
}
